import { BillReference, TransferReason } from '../../enums/transfer-reason.enum';

export function buildTransferReason(invoiceNumbers: string[]): string {
    // A bill without an invoice number comes back as 'N/A'; naming it would tell the reader nothing.
    const numbers = invoiceNumbers.filter(reference => !!reference && reference !== BillReference.NotAvailable);

    if (numbers.length === 0) return TransferReason.BillPayment;

    const label = numbers.length === 1 ? TransferReason.Invoice : TransferReason.Invoices;
    return `${TransferReason.BillPayment} - ${label} ${numbers.join(', ')}`;
}
